import { Component } from "@angular/core";
import { EceButtonComponent } from "./ece.button.component";

@Component({
  selector: "ece-btn-forward",
  templateUrl: "./ece.button.component.html",
  standalone: false
})
export class ForwardButtonComponent extends EceButtonComponent {
  icon = "redo";
}
